import styled, { css } from 'styled-components';
import { getColor, typeScale, StyleVars } from 'core/utils';

export const BreadcrumbsNav = styled.nav`
	color: ${getColor('mutedGray')};
	font-size: ${typeScale(1.5)};
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	line-height: ${typeScale(2.25)};
	min-height: ${typeScale(2.25)};
	margin-top: 12px;

	@media (min-width: ${StyleVars.screenSm}) {
		margin-top: 0;
	}

	span {
		padding: 0 ${typeScale(1)};
	}

	a {
		color: ${getColor('mutedGray')};
	}

	a:hover, a:focus, a:active {
		color: ${getColor('gray')};
	}
`;
